import React from 'react'

import { withStyles } from "@material-ui/core/styles";

import IconButton from '@material-ui/core/IconButton'
import Visibility from "@material-ui/icons/Visibility"
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import Edit from "@material-ui/icons/Edit"
import Delete from "@material-ui/icons/Delete"
import Table from "components/Table/Table.js"
import Circular from "components/Circular/Circular"
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContentText from '@material-ui/core/DialogContentText'
import Button from 'components/CustomButtons/Button.js'
import CustomInput from "components/CustomInput/CustomInput.js"
import CustomInputMask from "components/CustomInput/CustomInputMask.js"
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CSVReader from 'react-csv-reader';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import ExportCsv from "exportCsv.js";

import { getCondominioById } from "../../services/condominio/condominio";
import { getLockerById } from "../../services/lockers/lockers";

import { v4 as uuidv4 } from 'uuid';

import {
    getAllCondominos,
    getCondominoById,
    saveCondomino,
    deleteCondomino,
    updateCondomino,
    updateCondominoLocker
} from "../../services/condomino/condomino";

import { getLockerRelated } from "../../services/condominio/condominio";
import { createBrowserHistory } from "history";
import './condomino.css';
import SearchCondominos from 'components/Search/SearchCondominos';

const papaparseOptions = {
    header: true,
    dynamicTyping: false,
    skipEmptyLines: true,
    transformHeader: header =>
        header
            .toLowerCase()
            .replace(/\W/g, '_')
}

class Usuarios extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: '',
            nome: '',
            cpf: '',
            email: '',
            senha: '',
            telefone: '',
            ala: '',
            bloco: '',
            ap: '',

            load: true,
            loadSave: false,

            openModal: false,
            openModalDelete: false,
            deleteSelected: undefined,

            data: [],

            showSave: true,

            showValidation: false,

            currentUser: JSON.parse(localStorage.getItem("user")).data,

            sms: false,
            registroRaiz: false,
            exibitionName: '',
            condominoId: '',
            emailNotification: false,
            meuLockerApp: false,
            pwaApp: false,

            isAssociate: false,
            condominioId: null,
            allData: [],
            openModalDeleteAll: false,

            showForm: false,
            showButtonSearch: true
        }

        this.onNovo = this.onNovo.bind(this)
        this.onCancel = this.onCancel.bind(this)
        this.onEditar = this.onEditar.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onBuscaDados = this.onBuscaDados.bind(this)
        this.handleClickExportCSV = this.handleClickExportCSV.bind(this)
        this.deleteAllData = this.deleteAllData.bind(this)
        this.saveNewData = this.saveNewData.bind(this)
    }

    componentDidMount() {

        this.onBuscaDados()
    }

    onBuscaDados = () => {

        getAllCondominos(this.props.lockerId, (data) => {

            // console.log(JSON.stringify(data));

            data = data.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))


            getLockerRelated(this.props.lockerId, (res) => {
                if (res.length > 0) {
                    this.setState({ isAssociate: true, condominioId: res[0].condominioId });
                }

                if (data.length === 0) {
                    this.setState({ data: [], load: false })
                    return
                }

                const grid = data.map(item => {
                    console.log(JSON.stringify(item))


                    return [
                        item.name,
                        item.ap,
                        item.bloco,
                        item.ala,
                        item.email,
                        item.phone,
                        <div style={{textAlign: "center"}}>
                            {(item.app_pwa) && <WhatsAppIcon style={{fontSize: 18, marginRight: 2}}/>}
                            {(item.sms) && <SmsOutlinedIcon style={{fontSize: 18, marginRight: 2}}/>}
                            {(item.n_email) && <MailOutlineIcon style={{fontSize: 18, marginRight: 2}}/>}
                        </div>,
                        <>
                            <IconButton aria-label="view" onClick={() => this.onEditar(item)}>
                                <Edit className={this.props.classes.iconView} />
                            </IconButton>
                            <IconButton aria-label="view" onClick={() => this.setState({
                                openModalDelete: true,
                                deleteSelected: item
                            })}>
                                <Delete className={this.props.classes.iconView} />
                            </IconButton>

                            <IconButton aria-label="view" onClick={() => this.onShow(item)}>
                                <Visibility className={this.props.classes.iconView} />
                            </IconButton>
                        </>
                    ]
                })

                this.setState({
                    load: false,
                    data: grid,
                    allData: data
                })
            })
        })

    }

    onNovo = () => {
        this.setState({
            id: '',
            nome: '',
            cpf: '',
            email: '',
            senha: '',
            telefone: '',
            sms: true,
            emailNotification: '',
            meuLockerApp: '',
            pwaApp: true,
            ala: '',
            bloco: '',
            ap: '',
            openModal: true,
            showSave: true,
        })
    }

    onCancel = () => {
        this.setState({ openModal: false })
    }

    onDelete = () => {

        if (this.state.deleteSelected !== undefined) {
            deleteCondomino(this.state.deleteSelected.id, (data) => {
                this.setState({
                    openModalDelete: false
                });


                this.onBuscaDados();
            })
        }
    }

    deleteAllData = () => {
        const { allData } = this.state;

        this.setState({ load: true, openModalDeleteAll: false });

        allData.forEach((data, index) => {
            deleteCondomino(data.id, (deleted) => {
                if (index === allData.length - 1) {
                    this.onBuscaDados();
                }
            })


        });
    }

    onEditar = (item) => {

        const validString = (value) => {
            return value === '-' ? '' : value
        }

        this.setState({
            id: validString(item.id),
            nome: validString(item.name),
            cpf: validString(item.cpf),
            email: validString(item.email),
            senha: '',
            telefone: validString(item.phone),
            bloco: validString(item.bloco),
            ala: validString(item.ala),
            ap: validString(item.ap),
            meuLockerApp: validString(item.app_meu_locker),
            pwaApp: validString(item.app_pwa),
            emailNotification: validString(item.n_email),
            sms: validString(item.sms),
            registroRaiz: validString(item.registroRaiz),
            exibitionName: validString(item.exibitionName),
            condominoId: validString(item.condominoId),
            openModal: true,
            showSave: true
        })
    }

    onShow = (item) => {

        this.setState({
            id: item.id,
            nome: item.name,
            cpf: item.cpf,
            email: item.email,
            senha: '',
            telefone: item.phone,
            bloco: item.bloco,
            ala: item.ala,
            ap: item.ap,
            meuLockerApp: item.app_meu_locker,
            pwaApp: item.app_pwa,
            emailNotification: item.n_email,
            sms: item.sms,
            registroRaiz: item.registroRaiz,
            exibitionName: item.exibitionName,
            condominoId: item.condominoId,
            openModal: true,
            showSave: false
        })
    }

    saveNewData = (data) => {
        this.setState({ load: true });

        data.forEach((d, index) => {
            saveCondomino({
                name: d.nome ? String(d.nome) : '',
                email: d.email ? String(d.email) : '',
                password: d.senha ? String(d.senha) : '',
                cpf: d.cpf ? String(d.cpf) : '',
                phone: d.telefone ? String(d.telefone) : '',
                bloco: d.bloco ? String(d.bloco) : '',
                ala: d.ala ? String(d.ala) : '',
                ap: d.ap ? String(d.ap) : '',
                condominioId: this.state.condominioId,
                lockerId: this.props.lockerId,
                app_meu_locker: d.app_meu_locker === 'S',
                app_pwa: d.app_pwa === 'S',
                n_email: d.send_email === 'S',
                sms: d.send_sms === 'S',
                registroRaiz: d.registro_raiz === 'S',
                exibitionName: d.nome_exibicao,
                condominoId: d.id_condomino,
                // condominoId: d.id_condomino?d.id_condomino:((d.registro_raiz === 'S')?this.generateId(d.nome ? String(d.nome) : '' || d.nome_exibicao):d.id_condomino)
            }, (res) => {
                if (index == data.length - 1) {
                    this.onBuscaDados()
                }
            })
        });
    }

    generateId = async (name) => {
        let split = name.split(" ");
        let number = await this.between();
    
        const noSpecialChars = split[0].normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        const noSpecialChars2 = (split[1]) ? split[1].normalize('NFD').replace(/[\u0300-\u036f]/g, "") : "";
    
        let publicId = noSpecialChars + noSpecialChars2 + number;
    
        return publicId;
    };
    
   between = () => {
        return Math.floor(
            Math.random() * (10000 - 1000) + 1000
        )
    }

    onSave = () => {

        this.setState({ loadSave: true })

        if (this.state.id.length === 0) {
            saveCondomino({
                name: this.state.nome,
                email: this.state.email,
                password: this.state.senha,
                cpf: this.state.cpf,
                phone: this.state.telefone,
                bloco: this.state.bloco,
                ala: this.state.ala,
                ap: this.state.ap,
                condominioId: this.state.condominioId,
                lockerId: this.props.lockerId,
                app_meu_locker: this.state.meuLockerApp,
                app_pwa: this.state.pwaApp,
                n_email: this.state.emailNotification,
                sms: this.state.sms,
                registroRaiz: this.state.registroRaiz,
                exibitionName: this.state.exibitionName,
                condominoId: this.state.condominoId
                // condominoId: this.state.condominoId?this.state.condominioId:(this.state.registroRaiz?this.generateId(this.state.nome || this.state.exibitionName):this.state.condominioId)
            }, (data) => {

                this.setState({ loadSave: false, openModal: false })
                this.onBuscaDados()
            })
        }
        else {
            updateCondomino(
                this.state.id,
                {
                    name: this.state.nome,
                    email: this.state.email,
                    password: this.state.senha.length > 0 ? this.state.senha : undefined,
                    cpf: this.state.cpf,
                    phone: this.state.telefone,
                    bloco: this.state.bloco,
                    ala: this.state.ala,
                    ap: this.state.ap,
                    condominioId: this.state.condominioId,
                    lockerId: this.props.lockerId,
                    app_meu_locker: this.state.meuLockerApp,
                    app_pwa: this.state.pwaApp,
                    n_email: this.state.emailNotification,
                    sms: this.state.sms,
                    registroRaiz: this.state.registroRaiz,
                    exibitionName: this.state.exibitionName,
                    // condominoId: this.state.condominoId,
                    // condominoId: this.state.condominoId?this.state.condominioId:(this.state.registroRaiz?this.generateId(this.state.nome || this.state.exibitionName):this.state.condominioId),
                    condominoId: (this.state.condominoId && (this.state.condominoId != ""))?this.state.condominoId:(uuidv4()),
                },
                (data) => {

                    this.setState({ loadSave: false, openModal: false })
                    this.onBuscaDados()
                }
            )
        }
    }

    handleClickExportCSV = () => {
        let { allData, condominioId } = this.state;

        this.setState({ load: true });

        let documentData = new Promise((resolve, reject) => {
            let data = [];

            getCondominioById(condominioId, (cond) => {
                getLockerById(this.props.lockerId, (locker) => {
                    allData.forEach((d, index) => {
                        data.push({
                            'chave_registro': d.id,
                            'id_condomino': d.condominoId ? d.condominoId : '',
                            'nome': d.name ? d.name : '',
                            'email': d.email ? d.email : '',
                            'telefone': d.phone ? d.phone : '',
                            'cpf': d.cpf ? d.cpf : '',
                            'ala': d.ala ? d.ala : '',
                            'bloco': d.bloco ? d.bloco : '',
                            'ap': d.ap ? d.ap : '',
                            'senha': d.password,
                            'app_meu_locker': d.app_meu_locker ? 'S' : 'N',
                            'app_pwa': d.app_pwa ? 'S' : 'N',
                            'send_email': d.n_email ? 'S' : 'N',
                            'send_sms': d.sms ? 'S' : 'N',
                            'registro_raiz': d.registroRaiz ? 'S' : 'N',
                            'nome_exibicao': d.exibitionName ? d.exibitionName : '',
                            'fim': '',
                        });

                        if (index === allData.length - 1) {
                            resolve(data);
                        }
                    });
                });
            });
        });

        documentData.then((completeData) => {
            ExportCsv(completeData);
            this.onBuscaDados();
        })
    }

    updateCondominoLocker = () => {
        this.setState({ load: true });
        updateCondominoLocker(this.props.lockerId, (data) => {
            this.setState({ load: false });
        });
    }

    handleShowButtonSearch = (value, res, keepPainel) => {
        console.log('Pesquisa', value);

        var searchData = [];

        if (!res) {
            searchData = this.state.allData;
        } else {
            searchData = this.state.allData.filter((el) => ((el?.name?.toLowerCase().includes(value.toLowerCase())) || (el?.ala?.toLowerCase() == value.toLowerCase()) || (el?.bloco?.toLowerCase() == value.toLowerCase()) || (el?.ap?.toLowerCase() == value.toLowerCase())));
        }

        const grid = searchData.map(item => {
            return [
                item.name,
                item.ap,
                item.bloco,
                item.ala,
                item.email,
                item.phone,
                <>
                    <IconButton aria-label="view" onClick={() => this.onEditar(item)}>
                        <Edit className={this.props.classes.iconView} />
                    </IconButton>
                    <IconButton aria-label="view" onClick={() => this.setState({
                        openModalDelete: true,
                        deleteSelected: item
                    })}>
                        <Delete className={this.props.classes.iconView} />
                    </IconButton>

                    <IconButton aria-label="view" onClick={() => this.onShow(item)}>
                        <Visibility className={this.props.classes.iconView} />
                    </IconButton>
                </>
            ]
        })

        this.setState({ showButtonSearch: (value && !keepPainel) , showForm: (false || keepPainel), data: grid })

    //    console.log(keepPainel, JSON.stringify(searchData))
    }

    handleSearch = () => {
        const { showForm } = this.state;
        // const { finalResultAPI, showForm } = this.state;

        // const codeAndOperation = [];
        // const portaFilter = [];

        // const map = new Map();
        // const mapPorta = new Map();
        // for (const item of finalResultAPI) {
        //     if (!map.has(item.code)) {
        //         map.set(item.code, true);
        //         if (item.code && item.complemento) {
        //             codeAndOperation.push({
        //                 codigo: item.code,
        //                 operacao: (!item.complemento) ? null : item.complemento.replace(/[0-9]/g, 'X'),
        //             });
        //         }
        //     }

        //     if (!mapPorta.has(item.parametro1)) {
        //         mapPorta.set(item.parametro1, true);
        //         portaFilter.push({
        //             portaFilter: item.parametro1
        //         })
        //     }
        // }

        // console.log(portaFilter)

        this.setState({
            showForm: !showForm,
            showButtonSearch: false,
            // lockerAPI: finalResultAPI,
            // codeAndOperations: codeAndOperation.sort((a, b) => a.codigo - b.codigo), //.sort((a, b) => a.codigo.localeCompare(b.codigo)),
            // portaFilter: portaFilter
        });
    };

    render() {
        if (!localStorage.getItem("user")) {
            createBrowserHistory({ forceRefresh: true }).push("/");
        } else {
            createBrowserHistory({ forceRefresh: false }).push(`/`);
        }

        const { showForm, showButtonSearch } = this.state;
        console.log(showButtonSearch)

        return (

            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    {
                        this.state.load ? <Circular /> :
                            <>
                                <SearchCondominos
                                    show={showForm}
                                    filterTable={this.handleFilterTable}
                                    showButtonSearch={this.handleShowButtonSearch}
                                />
                                <div style={{flexDirection: "row", minWidth: "100%"}}>
                                    <Button color="primary" disabled={!this.state.isAssociate} onClick={this.onNovo} show={showButtonSearch}>Novo condômino</Button>
                                    <div style={{maxWidth: "100vw"}}></div>
                                    <Button color="default" disabled={!this.state.isAssociate || this.state.allData.length == 0} show={showButtonSearch} onClick={this.handleClickExportCSV} >EXPORTAR</Button>
                                    <Button color="primary" disabled={!this.state.isAssociate} show={showButtonSearch}>
                                        IMPORTAR
                                        <CSVReader
                                            cssClass="csv-reader-input"
                                            onFileLoaded={(data) => this.saveNewData(data)}
                                            parserOptions={papaparseOptions}
                                        />
                                    </Button>
                                    <Button color="default" onClick={this.updateCondominoLocker} show={showButtonSearch}>ATUALIZAR LOCKER</Button>
                                    <Button color="primary" onClick={this.handleSearch} show={showButtonSearch} >PESQUISAR</Button>
                                </div>

                                <Table
                                    tableHeaderColor="primary"
                                    tableHead={["Nome", "Apto", "Bloco", "Ala", "E-mail", "Telefone", "Notificação", "Ação"]}
                                    tableData={this.state.data}
                                />
                            </>
                    }
                </GridItem>

                <Dialog
                    open={this.state.openModal}
                    onClose={() => { }}
                    aria-labelledby="responsive-dialog-title"
                    fullWidth={true}
                //maxWidth='lg'
                >
                    <DialogTitle id="responsive-dialog-title">{(this.state.showSave) ? ((this.state.id === '') ? 'Novo condômino' : 'Editar condômino') : ''}</DialogTitle>
                    <DialogContent>

                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                                <CustomInput
                                    labelText="E-mail"
                                    id="email"
                                    name="email"
                                    type="text"
                                    role="presentation"
                                    value={this.state.email}

                                    inputProps={{
                                        value: this.state.email,
                                        autoComplete: "off",
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ email: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>



                            <GridItem xs={12} sm={12} md={6}>
                                <CustomInput
                                    labelText="Senha"
                                    id="senha"
                                    name="senha"
                                    value={this.state.senha}
                                    type="password"
                                    inputProps={{
                                        value: this.state.senha,
                                        autoComplete: "new-password",
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ senha: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>


                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Ala"
                                    id="ala"
                                    value={this.state.ala}

                                    inputProps={{
                                        value: this.state.ala,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ ala: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Bloco"
                                    id="bloco"
                                    value={this.state.bloco}

                                    inputProps={{
                                        value: this.state.bloco,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ bloco: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Apto"
                                    id="ap"
                                    value={this.state.ap}

                                    inputProps={{
                                        value: this.state.ap,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ ap: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Nome"
                                    id="nome"
                                    value={this.state.nome}

                                    inputProps={{
                                        value: this.state.nome,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ nome: event.target.value,
                                            exibitionName: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>


                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="CPF"
                                    id="cpf"
                                    value={this.state.cpf}

                                    inputProps={{
                                        value: this.state.cpf,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ cpf: event.target.value })
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Telefone Celular"
                                    id="telefone"
                                    value={this.state.telefone}

                                    inputProps={{
                                        value: this.state.telefone,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ telefone: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Nome de Exibição"
                                    id="exibitionName"
                                    value={this.state.exibitionName}

                                    inputProps={{
                                        value: this.state.exibitionName,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ exibitionName: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="ID Condomino"
                                    id="condominoId"
                                    value={this.state.condominoId}

                                    inputProps={{
                                        value: this.state.condominoId,
                                        // disableAnimation: true,
                                        onChange: event => this.setState({ condominoId: event.target.value }),
                                    }}
                                    formControlProps={{
                                        fullWidth: true,
                                        className: this.props.classes.inputMargin
                                    }}
                                />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={<Checkbox checked={this.state.registroRaiz} onChange={() => this.setState({ registroRaiz: !this.state.registroRaiz })} name="Registro Raiz" />}
                                        label="Registro raiz"
                                    />
                                </FormGroup>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                                <div style={{
                                    marginTop: '2rem',
                                    fontSize: '1rem',
                                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                    fontWeight: 400,
                                    lineHeight: 1.5,
                                    color: 'gray'
                                }}>Notificações:</div>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={<Checkbox checked={this.state.emailNotification} onChange={() => this.setState({ emailNotification: !this.state.emailNotification })} name="E-mail" />}
                                        label="E-mail"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={this.state.sms} onChange={() => this.setState({ sms: !this.state.sms })} name="SMS" />}
                                        label="SMS"
                                    />

                                    <FormControlLabel
                                        control={<Checkbox checked={this.state.pwaApp} onChange={() => this.setState({ pwaApp: !this.state.pwaApp })} name="WhatsApp" />}
                                        label="WhatsApp"
                                    />
                                </FormGroup>
                            </GridItem>

                        </GridContainer>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onCancel}>
                            Cancelar
                        </Button>
                        {
                            this.state.showSave ?
                                <Button onClick={this.onSave} color="primary">
                                    Salvar
                                </Button> : undefined
                        }
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openModalDelete}
                    onClose={() => this.setState({ openModalDelete: false, deleteSelected: undefined })}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">Deletar Condômino</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Este processo de deletar um condômino não pode ser desfeito, deseja continuar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openModalDelete: false })} color="default">
                            Cancelar
                        </Button>
                        <Button onClick={() => this.onDelete()} color="primary">
                            Deletar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openModalDeleteAll}
                    onClose={() => this.setState({ openModalDeleteAll: false })}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">Deletar Todos os Condôminos</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Este processo de deletar todos os condôminos não pode ser desfeito, deseja continuar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openModalDeleteAll: false })} color="default">
                            Cancelar
                        </Button>
                        <Button onClick={() => this.deleteAllData()} color="primary">
                            Deletar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={this.state.showValidation} autoHideDuration={6000} onClose={() => this.setState({ showValidation: false })}>
                    <MuiAlert onClose={() => this.setState({ showValidation: false })} elevation={6} variant="filled" severity='error'>
                        Você não tem permissão para realizar esta ação
                    </MuiAlert>
                </Snackbar>

            </GridContainer >
        )
    }
}

const styles = theme => ({
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    iconView: {
        color: "gray !important"
    },
    iconViewArrow: {
        color: "white !important",
    },
    buttonIcon: {
        padding: "5px"
    },
    dropdown: {
        right: "1.5%",
        top: "24%",
        position: "absolute"
    },
    removeMarginFromTop: {
        margin: 0
    },
    inputMargin: {
        marginTop: 10
    },

    lockerVinculadoView: {
        display: 'flex',
        flex: 1,
        background: '#f8f8f8',
        marginTop: 10,
        padding: 10,
        borderRadius: 2,
        borderBottomWidth: 1,
        borderBottomColor: '#ECECEC'
    },
    noButtonDeleteLockerUser: {
        padding: 5
    },
    divGrupos: {
        display: 'flex',
        flexDirection: 'row'
    },
    divItemGrupo: {
        width: '50%'
    }
});

export default withStyles(styles)(Usuarios);
